import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/pancake_batter.png";
import cooked from "../../assets/images/ingredients/PancakeCooking.png";

const Pancake = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Pancake"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Pancake;